import { useNavigate } from 'react-router-dom'

export const LearnAboutThisService = () => {
  const navigate = useNavigate()
  return (
    <div className='absolute bottom-2 sm:right-6 sm:left-auto sm:margin-auto right-0 left-0 margin-0 text-center text-[#001A3D] font-medium text-xs sm:text-sm'>
      <button onClick={() => navigate('learn-more')} className='text-underline'>
        Learn about this service
      </button>
    </div>
  )
}
